import * as React from 'react';

import { Box, Flex } from '@chakra-ui/react';

interface IIndexOfListItem {
  index: string;
  children: React.ReactNode;
}

export const ListItemTitle: React.FC<IIndexOfListItem> = ({
  index,
  children,
}) => {
  return (
    <Flex mb='sm'>
      <Flex
        align='center'
        background='app.pink'
        borderRadius='100%'
        color='app.white'
        fontSize='15px'
        fontWeight='900'
        h='27px'
        justify='center'
        w='27px'
      >
        {index}
      </Flex>

      <Box fontSize='xl' fontWeight='bold' ml='sm'>
        {children}
      </Box>
    </Flex>
  );
};
